export default __webpack_public_path__ + "static/AA030111_Cit_ExtSide-111-01a_534x360-2a609f9fd6c31d0b221ef2efad3374da.jpg";